import React from 'react';
import { Button, Input, Select, DatePicker } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { SORT_OPTIONS } from '../../../../constants/delivery.constants';


const { RangePicker } = DatePicker;

interface DeliveryFilterBarProps {
  sortVal: string;
  setSortVal: (val: string) => void;
  dropdownVisible: boolean;
  setDropdownVisible: (visible: boolean) => void;
  handleReset: () => void;
  search: string;
  setSearch: (search: string) => void;
  handleSearchChange: (value: string) => void;
  handleSearch: (value: string) => void;
  setCreated_at__gte: (val: any) => void;
  setCreated_at__lte: (val: any) => void;
  setDispatchTime__gte: (val: any) => void;
  setDispatchTime__lte: (val: any) => void;
  setDeliveryTime__gte: (val: any) => void;
  setDeliveryTime__lte: (val: any) => void;
  deliveriesView: boolean;
  etasView: boolean;
  etasSearch: string;
  setEtasSearch: (val: string) => void;
  city: string;
  setCity: (val: string) => void;
}

export const DeliveryFilterBar = ({
  sortVal,
  setSortVal,
  dropdownVisible,
  setDropdownVisible,
  handleReset,
  search,
  setSearch,
  handleSearchChange,
  handleSearch,
  setCreated_at__gte,
  setCreated_at__lte,
  setDispatchTime__gte,
  setDispatchTime__lte,
  setDeliveryTime__gte,
  setDeliveryTime__lte,
  deliveriesView,
  etasView,
  etasSearch,
  setEtasSearch,
  city,
  setCity,
}: DeliveryFilterBarProps) => {
  if (etasView) {
    return (
      <div className="d-flex align-items-center gap-3 mb-3 flex-wrap">
        <Input.Search
          placeholder="Search by Trip Name, PO Number or Lead ID"
          style={{ width: 340 }}
          value={etasSearch}
          onChange={(e) => setEtasSearch(e.target.value)}
          onSearch={setEtasSearch}
          allowClear
        />
        <RangePicker
          placeholder={['Dispatch Start', 'Dispatch End']}
          style={{ width: 260 }}
          onChange={(event) => {
            if (event) {
              setDispatchTime__gte(event[0]?.format('YYYY-MM-DD'));
              setDispatchTime__lte(event[1]?.add(1, 'day')?.format('YYYY-MM-DD'));
            } else {
              setDispatchTime__gte(undefined);
              setDispatchTime__lte(undefined);
            }
          }}
        />
      </div>
    );
  }

  return (
    <div className="d-flex align-items-center gap-3 mb-3 flex-wrap">
      <Select
        placeholder="Sort by Created At Asc"
        style={{ width: 200 }}
        value={sortVal}
        onChange={setSortVal}
        options={SORT_OPTIONS.map((item: any) => ({
          value: item?.value,
          label: item?.label,
        }))}
      />
      
      {dropdownVisible && (
        <Button onClick={handleReset}>Reset</Button>
      )}
      
      <Input.Search
        style={{ width: 280 }}
        placeholder="Search by PO No./Lead ID/Vendor Name"
        value={search}
        onChange={(e) => handleSearchChange(e.target.value)}
        onSearch={handleSearch}
        allowClear
      />
      
      <Button 
        icon={<FilterOutlined />}
        onClick={() => setDropdownVisible(!dropdownVisible)}
      />

      {dropdownVisible && (
        <div className="d-flex gap-3 mt-3 flex-wrap w-100">
          <div>
            <RangePicker
              placeholder={["Created Date", "Created Date"]}
              style={{ width: 240 }}
              onChange={(event) => {
                if (event) {
                  if (deliveriesView) {
                    setDeliveryTime__gte(event[0]?.format("YYYY-MM-DD"));
                    setDeliveryTime__lte(event[1]?.add(1, "day")?.format("YYYY-MM-DD"));
                  } else {
                    setCreated_at__gte(event[0]?.format("YYYY-MM-DD"));
                    setCreated_at__lte(event[1]?.add(1, "day")?.format("YYYY-MM-DD"));
                  }
                } else {
                  setCreated_at__gte(undefined);
                  setCreated_at__lte(undefined);
                  setDeliveryTime__gte(undefined);
                  setDeliveryTime__lte(undefined);
                }
              }}
            />
          </div>
          
          <div>
            <RangePicker
              placeholder={["Dispatch Date", "Dispatch Date"]}
              style={{ width: 240 }}
              onChange={(event) => {
                if (event) {
                  setDispatchTime__gte(event[0]?.format("YYYY-MM-DD"));
                  setDispatchTime__lte(event[1]?.add(1, "day")?.format("YYYY-MM-DD"));
                } else {
                  setDispatchTime__gte(undefined);
                  setDispatchTime__lte(undefined);
                }
              }}
            />
          </div>
          
          <div>
            <RangePicker
              placeholder={["Delivery Date", "Delivery Date"]}
              style={{ width: 240 }}
              onChange={(event) => {
                if (event) {
                  setDeliveryTime__gte(event[0]?.format("YYYY-MM-DD"));
                  setDeliveryTime__lte(event[1]?.format("YYYY-MM-DD"));
                } else {
                  setDeliveryTime__gte(undefined);
                  setDeliveryTime__lte(undefined);
                }
              }}
              allowClear
            />
          </div>
          <div>
            <Select
              value={city}
              onChange={setCity}
              style={{ width: 150 }}
              options={[
                { value: "All", label: "All Cities" },
                { value: "blr", label: "BLR" },
                { value: "hyd", label: "HYD" },
              ]}
            />
          </div>
        </div>
      )}
    </div>
  );
};
